"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OldestColumn = exports.CountColumn = exports.NameSortColumn = void 0;
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
function NameSortColumn(_a) {
    var row = _a.row, editHref = _a.editHref;
    return (react_1.default.createElement("td", { className: "table-cell" },
        react_1.default.createElement("a", { className: "anchor-full-row-clickable", href: editHref(row) }, row === null || row === void 0 ? void 0 : row.label)));
}
exports.NameSortColumn = NameSortColumn;
function CountColumn(_a) {
    var row = _a.row, editHref = _a.editHref;
    return (react_1.default.createElement("td", { className: "table-cell" },
        react_1.default.createElement("a", { className: "anchor-full-row-clickable", href: editHref(row) },
            react_1.default.createElement("span", { "data-cy": "row-count", className: (0, clsx_1.default)({ 'positive-count-display': row.count }) },
                ' ',
                row.count))));
}
exports.CountColumn = CountColumn;
function OldestColumn(_a) {
    var row = _a.row, editHref = _a.editHref;
    return (react_1.default.createElement("td", { className: "table-cell", title: row.oldestFormatted },
        react_1.default.createElement("a", { className: " anchor-full-row-clickable manual-queues-row-time", href: editHref(row) }, row.oldestHumanized)));
}
exports.OldestColumn = OldestColumn;
